import React from 'react';
import { cn } from '../../shared/util/cn';

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'outline-solid';
  size?: 'sm' | 'md' | 'lg';
}

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant = 'default', size = 'md', children, ...props }, ref) => {
    const variants = {
      default: 'bg-[var(--color-mockup-text-light)]/15 text-[var(--color-mockup-text-mid)] dark:bg-[var(--color-mockup-text-mid)]/30 dark:text-[var(--color-mockup-text-light)]',
      primary: 'bg-primary/15 text-primary border border-primary/30 dark:bg-primary/25 dark:border-primary/40',
      secondary: 'bg-secondary/15 text-secondary border border-secondary/30 dark:bg-secondary/25 dark:border-secondary/40',
      success: 'bg-[var(--color-mockup-teal-light)] text-[var(--color-mockup-teal)] border border-[var(--color-mockup-teal)]/30 dark:border-[var(--color-mockup-teal)]/40',
      warning: 'bg-[var(--color-mockup-amber-light)] text-[var(--color-mockup-amber)] border border-[var(--color-mockup-amber)]/30 dark:border-[var(--color-mockup-amber)]/40',
      danger: 'bg-[var(--color-mockup-coral-light)] text-[var(--color-mockup-coral)] border border-[var(--color-mockup-coral)]/30 dark:border-[var(--color-mockup-coral)]/40',
      'outline-solid': 'border-2 border-[var(--color-mockup-border)] text-[var(--color-mockup-text)] dark:border-[var(--color-mockup-border)] dark:text-[var(--color-mockup-text)]',
    };

    const sizes = {
      sm: 'px-2 py-0.5 text-[10px]',
      md: 'px-2.5 py-1 text-xs',
      lg: 'px-3 py-1.5 text-sm',
    };

    return (
      <div
        ref={ref}
        className={cn(
          'inline-flex items-center rounded-full font-bold tracking-wide',
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Badge.displayName = 'Badge';
